var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 54,
    viewBox: "0 0 63 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30853 1H34.6471C38.1314 1 40.9559 3.4484 40.9559 6.46866V17.406C40.9559 18.4128 40.0144 19.2289 38.8529 19.2289C37.6915 19.2289 36.7499 18.4128 36.7499 17.406V6.46866C36.7499 5.46187 35.8084 4.64573 34.6469 4.64573H7.30841C6.14693 4.64573 5.2054 5.46187 5.2054 6.46866V46.5722C5.2054 47.579 6.14693 48.3951 7.30841 48.3951H34.6471C35.8085 48.3951 36.7501 47.579 36.7501 46.5722V35.6349C36.7501 34.6281 37.6916 33.8119 38.8531 33.8119C40.0145 33.8119 40.9561 34.6281 40.9561 35.6349V46.5722C40.9561 49.5924 38.1315 52.0408 34.6472 52.0408H7.30865C3.82434 52.0408 0.999771 49.5924 0.999771 46.5722V6.46866C0.999649 3.4484 3.82423 1 7.30853 1Z",
    fill: "#F30707",
    stroke: "#F30707",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2867 24.4188H54.7101L47.677 17.3814C46.8576 16.5324 46.8811 15.1795 47.7296 14.3596C48.5573 13.5598 49.8694 13.5598 50.6969 14.3596L61.3758 25.0448C61.5741 25.2434 61.7309 25.4795 61.837 25.7394C62.053 26.2622 62.053 26.8494 61.837 27.3721C61.7304 27.633 61.5729 27.8698 61.3736 28.0689L50.6949 38.7541C49.8755 39.6031 48.5235 39.6266 47.675 38.8067C46.8266 37.9868 46.803 36.6339 47.6225 35.7849C47.6396 35.7672 47.6571 35.7496 47.675 35.7323L54.7101 28.6928H19.2865C18.1069 28.6928 17.1507 27.736 17.1507 26.5557C17.1507 25.3754 18.1071 24.4188 19.2867 24.4188Z",
    fill: "#F30707",
    stroke: "#F30707",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.185652e38d1aacdbea83be16b0055c45.svg";
export { ForwardRef as ReactComponent };